module.exports = __webpack_public_path__ + "img/ad8a10d.jpg";